import { getRestaurantServiceClient } from "../lib/connect";
import { Location, LocationSummary } from "../models/location";

// storageTimestamp is stamped by the caller when the selection is persisted,
// not returned by the service.
export const getLocation = async (
  locationNumber: string
): Promise<Omit<Location, "storageTimestamp">> => {
  const { restaurant } =
    await getRestaurantServiceClient().singleRestaurantSearch({
      locationNumber,
    });

  if (restaurant == null) {
    throw new Error(`No restaurant returned for location ${locationNumber}`);
  }

  return {
    name: restaurant.name,
    locationNumber: restaurant.locationNumber,
    // Bridge Time — see useDelayedStatus. Absent settings mean no delay.
    mobileOrderingSettings: {
      isNotificationDelayed:
        restaurant.mobileOrderSettings?.isNotificationDelayed ?? false,
      notificationDelayInSeconds:
        restaurant.mobileOrderSettings?.notificationDelaySeconds,
    },
  };
};

export const getLocationSummaries = async (): Promise<LocationSummary[]> => {
  const { locationSummaries } =
    await getRestaurantServiceClient().locationSummary({});

  return locationSummaries.map(({ locationNumber, name }) => ({
    locationNumber,
    name,
  }));
};
